import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  // public imagesUrl;
  constructor() { }

  ngOnInit() {
    // this.imagesUrl = [
    //   'https://ed.iitm.ac.in/~vb/assets/img/1.jpg',
    //   'https://ed.iitm.ac.in/~vb/assets/img/6.jpg',
    //   // 'assets/Gallery/EventPhotos/15/1.jpg'
    // ];
  }

}


